import { createAction } from 'redux-act'

export const setLoggedUser = createAction('APP_SET_LOGGED_USER')
